import * as React from 'react'
import { CloudHub2SettingsIcon } from './CloudHub2SettingsIcon'
import './CloudHub2SettingsPage.css'

export type ValueProps = {}

export type EventProps = {}

export type Props = ValueProps & EventProps

export class CloudHub2SettingsPage extends React.Component<Props, {}> {
  
  render() {
    return (
      <div className="cloudhub2-settings-page" data-test-id="cloudhub2-settings-page">
        <div className="cloudhub2-settings-page-icon" data-test-id="cloudhub2-settings-page-icon">
          <CloudHub2SettingsIcon/>
        </div>
        <div className="cloudhub2-settings-page-title-container" data-test-id="cloudhub2-settings-page-title-container">
          <span className="cloudhub2-settings-page-title" data-test-id="cloudhub2-settings-page-title">
            Anypoint Monitoring is enabled by default for all CloudHub 2.0 applications.
          </span>
        </div>
      </div>
    )
  }
}
